export const TYPE = "congtynhap"